import AppRouter from "./routes/appRouter";
import SaqaDataTest from "./components/SaqaDataTest";

export default function App() {
  return (
    <>
      <AppRouter />
    </>
  );
}
